module.exports = __webpack_public_path__ + "d38b034a29af70f5925b0a1a89d67897.svg";